module.exports = __webpack_public_path__ + "static/media/d6ru.15abd3ad.pdf";